var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23 18.5313V21.1667C23 22.1796 22.1796 23 21.1667 23H2.83333C1.82042 23 1 22.1796 1 21.1667V8.33333C1 7.32042 1.82042 6.5 2.83333 6.5H8.33333M1 12H8.33333",
    stroke: "#D8032B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17 16C20.3 16 23 13.3 23 10C23 6.7 20.3 4 17 4C13.7 4 11 6.7 11 10C11 13.3 13.7 16 17 16Z",
    stroke: "#D8032B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15 12L19 8",
    stroke: "#D8032B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19 12L15 8",
    stroke: "#D8032B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBlock);
export default __webpack_public_path__ + "static/media/card-block.b13e5548e9f1e069c0264cc0569e1285.svg";
export { ForwardRef as ReactComponent };